<!----------------- BEGIN TS ---------------------->
<script lang="ts">
import { initPopover } from "@/plugins/bootstrapSetup";
import { Popover } from "bootstrap";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class TheComplianceToggleButton extends Vue {
  // ---------- Props ----------

  /** Whether or not compliance control is showing */
  @Prop() showCompliance!: boolean;

  /** Show the map only if the lat and lng is not 0 and all fields exist. */
  @Prop() canShowAtAll!: boolean;

  // ------- Local Vars --------

  /** Reference to all popovers so we can modify them (Note that in this component, there is only one). */
  popovers!: Popover[];

  // --------- Watchers --------

  @Watch("showCompliance")
  setDynamicHelpMessage(): void {
    // Need to essentially delete and rebuild because otherwise popover content doesn't change
    if (this.popovers) {
      // NOTE: there is only one, but this is for robustness
      this.popovers.forEach((popover) => {
        popover.dispose();
      });
      this.popovers = initPopover(
        this.$refs.complianceButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // ------- Lifecycle ---------

  mounted(): void {
    if (this.$refs.complianceButton) {
      this.popovers = initPopover(
        this.$refs.complianceButton as Element,
        this.dynamicHelpMessage
      );
    }
  }
  // --------- Methods ---------

  /** Choose an icon based on the state. */
  get chooseIcon(): string[] {
    if (this.showCompliance) {
      return ["eye"];
    } else {
      return ["eye-slash"];
    }
  }

  /** Gets the dynamic help message. */
  get dynamicHelpMessage(): string {
    if (this.showCompliance) {
      return "Hide Compliance Events.";
    } else {
      return "Show Compliance Events.";
    }
  }
}
</script>
<!----------------- END TS ------------------------>

<!----------------- BEGIN HTML -------------------->
<template lang="html">
  <div
    class="the-compliance-toggle-button-container"
    ref="complianceButton"
    v-if="canShowAtAll"
  >
    <button
      type="button"
      class="btn btn-light compliance-toggle-button text-dark"
      @click="$emit('update-compliance-state')"
      data-bs-toggle="popover"
      data-bs-trigger="hover"
      data-bs-container="#app-container"
      data-bs-html="true"
      :data-bs-content="`<span>${dynamicHelpMessage}</span>`"
    >
      <b-iconstack class="icon" font-scale="2">
        <b-icon
          stacked
          v-for="(icon, index) in chooseIcon"
          :key="`icon-${index}`"
          :icon="icon"
          :scale="index > 0 ? '2.5' : '.85'"
        ></b-icon>
      </b-iconstack>
    </button>
  </div>
</template>
<!----------------- END HTML ---------------------->

<!----------------- BEGIN SCSS -------------------->
<style scoped lang="scss">
// Override SCSS Classes here
.the-compliance-toggle-button-container {
  display: flex;
  margin-left: auto;

  .compliance-toggle-button {
    box-shadow: 4px 7px 4px 0px rgb(0 0 0 / 25%);
    border-radius: 0px 0px 10px 10px;
    cursor: pointer;
    font-size: 14px;
    max-height: 71px;

    .icon {
      width: 30px;
      @media only screen and (max-width: 600px),
        screen and (max-height: 550px) {
        width: 20px;
      }

      @media only screen and (max-width: 500px),
        screen and (max-height: 400px) {
        width: 10px;
      }
    }
  }
}
</style>
<!----------------- END SCSS ---------------------->
